export interface BillingStatusFilterOption {
  value: string
  label: string
  /** Valor para `statusFilter` del query. `undefined` = sin filtro (todas). */
  statusFilter?: string[]
}

/**
 * Opciones del filtro de estado. Mapean a los valores reales de `BillingStatus`
 * (PENDING, PAID, PARTIALLY_PAID, REFUNDED, CANCELLED). No existe "Vencida".
 */
export const BILLING_STATUS_FILTERS: BillingStatusFilterOption[] = [
  { value: 'all', label: 'Todas' },
  { value: 'PENDING', label: 'Pendientes', statusFilter: ['PENDING'] },
  { value: 'PARTIALLY_PAID', label: 'Pago parcial', statusFilter: ['PARTIALLY_PAID'] },
  { value: 'PAID', label: 'Pagadas', statusFilter: ['PAID'] },
  { value: 'REFUNDED', label: 'Reembolsadas', statusFilter: ['REFUNDED'] },
  { value: 'CANCELLED', label: 'Canceladas', statusFilter: ['CANCELLED'] },
]

/** Estados en los que la factura todavía se puede pagar. */
export const PAYABLE_STATUSES = new Set(['PENDING', 'PENDING_PAYMENT', 'PARTIALLY_PAID', 'OVERDUE'])
